module.exports = __webpack_public_path__ + "img/bg_video5.e1f92cd6.jpg";